export enum Locales {
    DE = 'de',
    FR = 'fr',
    IT = 'it',
    EN = 'en'
}

export const LOCALES = [
    {value: Locales.DE, caption: 'Deutsch'},
    {value: Locales.FR, caption: 'Français'},
    {value: Locales.IT, caption: 'Italiano'},
    {value: Locales.EN, caption: 'English'},
]